<template>
  <van-pull-refresh
    style="min-height: 100vh"
    v-model="refreshing"
    @refresh="onRefresh"
  >
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      style="background-color: #f1f1f1;"
    >
      <div style="padding: 1rem;height: 100%">
        <div v-for="(item, index) in data" :key="index" class="counpon-list">
          <div class="counpon-list-item">
            <div>
              <img
                style="width: 3rem;height: 3rem;margin-right: 1rem"
                :src="item.img"
                alt="图片"
              />
            </div>
            <div>
              <div>
                {{ item.name }}
              </div>
              <div style="font-size: 0.8rem;color: red">￥{{ item.fee }}</div>
            </div>
          </div>
          <div>
            {{ item.describe }}
          </div>
        </div>
      </div>
    </van-list>
  </van-pull-refresh>
</template>
<script>
import { getCouponList } from '@/api/api';
import { PullRefresh, List, Toast } from 'vant';
export default {
  components: {
    VanPullRefresh: PullRefresh,
    VanList: List,
  },
  data() {
    return {
      data: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      total: 0,
    };
  },
  methods: {
    async handleGet() {
      try {
        this.loading = true;
        const {
          data: { data, total },
        } = await getCouponList({ page: this.page, pagesize: 10 });
        this.data = [...this.data, ...data];
        this.total = total;
        if (this.refreshing) {
          Toast('刷新成功');
        }
      } catch {
      } finally {
        this.loading = false;
        this.refreshing = false;
      }
    },
    onLoad() {
      this.loading = false;
      if (this.data.length > 0) {
        if (this.data.length < this.total) {
          this.page++;
          this.handleGet();
        } else if (this.data.length === this.total) {
          this.finished = true;
        }
      } else {
        this.page = 1;
        this.handleGet();
      }
    },
    onRefresh() {
      this.refreshing = true;
      this.finished = false;
      this.data = [];
      this.total = 0;
      this.onLoad();
    },
  },
};
</script>
<style scoped lang="scss">
.counpon-list {
  background-color: #fff;
  padding: 0.5rem 0.5rem;
  margin-bottom: 1rem;
  text-align: left;
  border-radius: 6px;
  .counpon-list-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 0.5rem;
  }
}
</style>
